import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { ZERO } from '@morpho-org/dapp-core';
import { Donut, getDonutColor } from '@morpho-org/ui-v6/server';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { memo, useMemo } from 'react';
import { formatUnits } from 'viem';
interface CellAllocationWithAmountProps {
  allocation: bigint;
  supplyAssets: bigint;
  token: InterfaceToken | null | undefined;
  percentageOffset: bigint;
  index: number;
}
function CellAllocationWithAmount(t0) {
  const $ = _c(34);
  const {
    allocation,
    supplyAssets,
    token,
    percentageOffset,
    index
  } = t0;
  let t1;
  if ($[0] !== supplyAssets || $[1] !== token?.decimals) {
    t1 = formatters.short.default("0").trailingZero(false).digits(2).of(supplyAssets, token?.decimals);
    $[0] = supplyAssets;
    $[1] = token?.decimals;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedAllocation = t1;
  let t2;
  if ($[3] !== supplyAssets || $[4] !== token) {
    const usdValue = token?.toUsd(supplyAssets) ?? ZERO;
    t2 = formatters.short.default("0").trailingZero(false).digits(2).unit("$").of(usdValue, 18);
    $[3] = supplyAssets;
    $[4] = token;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const formattedAllocationUsd = t2;
  let t3;
  if ($[6] !== allocation) {
    t3 = formatters.percent.digits(2).unit("%").of(allocation, 18);
    $[6] = allocation;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const formattedPercentage = t3;
  let t4;
  if ($[8] !== allocation) {
    t4 = formatUnits(allocation, 18);
    $[8] = allocation;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const percentShareNumber = Number(t4) * 100;
  let t5;
  if ($[10] !== percentageOffset) {
    t5 = formatUnits(percentageOffset, 18);
    $[10] = percentageOffset;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const formattedPercentageOffset = Number(t5) * 100;
  let t6;
  if ($[12] !== index) {
    t6 = getDonutColor(index);
    $[12] = index;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const donutColor = t6;
  let t7;
  if ($[14] !== donutColor || $[15] !== formattedPercentageOffset || $[16] !== percentShareNumber) {
    t7 = <TooltipTrigger asChild={true}><div className="flex cursor-default" onClick={_temp}><Donut allocation={percentShareNumber} color={donutColor} backgroundColor="var(--color-muted)" percentageOffset={formattedPercentageOffset} /></div></TooltipTrigger>;
    $[14] = donutColor;
    $[15] = formattedPercentageOffset;
    $[16] = percentShareNumber;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = `Vault allocation: ${formattedPercentage}`;
  let t9;
  if ($[18] !== t8) {
    t9 = <TooltipContent>{t8}</TooltipContent>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t9) {
    t10 = <Tooltip>{t7}{t9}</Tooltip>;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      whiteSpace: "nowrap"
    };
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== formattedAllocation) {
    t12 = <TooltipTrigger asChild={true}><span className="text-2xs text-foreground" style={t11}>{formattedAllocation}</span></TooltipTrigger>;
    $[24] = formattedAllocation;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== formattedAllocationUsd) {
    t13 = <TooltipContent>{formattedAllocationUsd}</TooltipContent>;
    $[26] = formattedAllocationUsd;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <Tooltip>{t12}{t13}</Tooltip>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t10 || $[32] !== t14) {
    t15 = <div className="gap-xs flex items-center">{t10}{t14}</div>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
}
function _temp(e) {
  e.stopPropagation();
}
export default memo(CellAllocationWithAmount);